import { OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseEntity } from '../models/baseEntity';
import { EntityContainer } from '../models/entityContainer';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';


export abstract class BasePage2<E extends BaseEntity> implements OnInit {

  isSearchForm // ???
  
  @Input() embeded : boolean = false;
  @Output() onClose = new EventEmitter<any>();

  serverPageNumber  : number = 0;
  serverPageCount   : number = 0;
  totalRowCount     : number = -1;

  entityContainer   : EntityContainer<E>;
  selectedRow       : BaseEntity = null;
  selectedRowIndex  : number;

  readOnly          : boolean = false;
  listFields        = [];
  formFields        = [];
  childFields       = [];
  confirmationMessage : string = "Confirmation";
  entityName          : string;


  constructor(
    protected toastr            : ToastrService,
    protected router            : Router,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService,
    protected location          : Location) { }

  ngOnInit() {}

  ngAfterViewInit(){

    if (this.entityName)  {
      this.baseService.fieldsGet(this.entityName).then(result => {

        if (result.listFields.length > 0) {
          this.listFields = result.listFields;
          this.formFields = result.formFields;
          this.readOnly   = result.readOnly;
        }
        this.processFields();
      })
    }
  }
  
  processFields(){
    this.listFields.forEach(field => { this.enrichField(field);})
    this.formFields.forEach(field => { this.enrichField(field);})
  }

  enrichField(field){
  }

  abstract getRows()            : BaseEntity[];

  

  showError(message : string){
    this.toastr.error(message);
  }
     
  showSuccessFulOperation(){
    this.toastr.success('Opération effectuée avec succès');
  }

 
  selectRow(row : any){
    this.selectedRowIndex = this.getRows().indexOf(row);
    this.selectedRow = row;
  }
      
  selectRow2(row : any){
    this.selectedRow = row.selected[0];
  }
  
  saveRow(row : BaseEntity) : Promise<BaseEntity>{ return null}
  
  save(row : BaseEntity){
    this.saveRow(row).then(result => {
      this.leanUtilsService.success();
      if (row.inserted) {
        this.getRows().push(row);
        row.inserted  = false;
        row.edit      = false;
      } else {
        if (row.updated) {
          let index = this.getRows().indexOf(row);
          this.getRows()[index] = result;
          row.updated   = false;
          row.edit      = false;
        } else { // deleted
          let index = this.getRows().indexOf(row);
          this.getRows().splice(index, 1);
        }
      }
    })
    .catch(err => {
      this.showError(err)
    })
  }


  returnBack(x :any){
    if (! this.embeded) {
      this.location.back();
    } else {
      this.onClose.emit(null);
    }
  }

  closeWidget(entity: any) {
   if ( (entity != null) && (this.selectedRowIndex != null)) {
    this.getRows()[this.selectedRowIndex] = entity;
    this.selectedRowIndex = null;
   }
    this.selectedRow = null;
  }

  nextPage() {
    if (this.serverPageNumber < (this.serverPageCount - 1)) {
      this.serverPageNumber++;
      this.loadData()
    }
  }
  previousPage() {
    if (this.serverPageNumber > 0) {
      this.serverPageNumber--;
      this.loadData()
    }
  }

  loadData() {}

}
